export default __webpack_public_path__ + "static/media/Alien.62603b33.webm";